import styled from 'styled-components'

export const ActiveArrowIcons = styled.span<{ $active: boolean; $color?: string }>`
  width: 16px;
  height: 16px;
  position: relative;
  right: 0;

  &:before,
  &:after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    margin: auto;
    width: 1.5px;
    height: 16px;
    border-bottom: 8px solid ${(props) => props.$color ?? 'var(--black-30)'};
    box-sizing: border-box;
    transform-origin: center;
    transition: all 0.2s ease;
  }

  &:before {
    top: ${(props) => (props.$active ? '-3px' : '3px')};
    transform: ${(props) => (props.$active ? 'rotate(45deg)' : 'rotate(135deg)')};
  }

  &:after {
    top: ${(props) => (props.$active ? '-3px' : '3px')};
    transform: ${(props) => (props.$active ? 'rotate(-45deg)' : 'rotate(-135deg)')};
  }
`
